export default __webpack_public_path__ + "static/media/Body Temp disabled.71410062.svg";